import { useEffect, useRef } from 'react';
import { useLocation, useNavigationType } from 'react-router-dom';

const getStickyHeaderOffset = () => {
  const header = document.querySelector('.header');
  const headerHeight = header instanceof HTMLElement ? header.offsetHeight : 64;

  return headerHeight + 16;
};

export const useScrollRestoration = (enabled: boolean, key?: string) => {
  const location = useLocation();
  const navigationType = useNavigationType();
  const restoredRef = useRef(false);
  const storageKey = `scroll:${key ?? `${location.pathname}${location.search}`}`;

  useEffect(() => {
    const saveScrollPosition = () => {
      sessionStorage.setItem(storageKey, String(window.scrollY));
    };

    window.addEventListener('scroll', saveScrollPosition, { passive: true });

    return () => {
      saveScrollPosition();
      window.removeEventListener('scroll', saveScrollPosition);
    };
  }, [storageKey]);

  useEffect(() => {
    if (!enabled || navigationType !== 'POP' || restoredRef.current) {
      return;
    }

    const savedScroll = sessionStorage.getItem(storageKey);
    if (savedScroll === null) {
      return;
    }

    const top = Number(savedScroll);
    if (Number.isNaN(top)) {
      return;
    }

    restoredRef.current = true;

    const frameId = window.requestAnimationFrame(() => {
      window.scrollTo({ top: Math.max(0, top - getStickyHeaderOffset()), behavior: 'auto' });
    });

    return () => {
      window.cancelAnimationFrame(frameId);
    };
  }, [enabled, navigationType, storageKey]);
};
